import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    initialLoading: false,
    loading: false,
    errorMessage: null,
    dataPage: null,

    filterInformation: null,
    filterInformationLoading: false,
    filterInformationErrorMessage: null,

    selectedOrderData: null,
    orderDetailsModal: false,
    orderDetailsLoading: false,
    orderDetailsErrorMessage: null,

    generateDocumentsLoading: false,
    generateDocumentsErrorMessage: null,

    generateReversalDocumentLoading: false,
    generateReversalDocumentErrorMessage: null,

    generateSingleDocumentLoading: {},
    generateSingleDocumentErrorMessage: null,

    regenerateDocumentLoading: {},
    regenerateDocumentErrorMessage: null,

    orderEvents: null,
    orderEventsLoading: false,
    orderEventsErrorMessage: null,
};

const pathwayBillingDataSlice = createSlice({
    name: "PathwayBillingData",
    initialState,
    reducers: {
        getFilterInformationRequest(state) {
            state.filterInformation = null;
            state.filterInformationLoading = true;
            state.filterInformationErrorMessage = null;
        },
        getFilterInformationSuccess(state, action) {
            state.filterInformation = action.payload;
            state.filterInformationLoading = false;
        },
        getFilterInformationFailure(state, action) {
            state.filterInformationLoading = false;
            state.filterInformationErrorMessage = action.payload;
        },

        getInitialOrderDataListRequest(state) {
            state.initialLoading = true;
            state.errorMessage = null;
            state.dataPage = null;
        },
        getOrderDataListRequest(state) {
            state.loading = true;
            state.errorMessage = null;
        },
        getOrderDataListSuccess(state, action) {
            state.initialLoading = false;
            state.loading = false;
            state.dataPage = action.payload;
        },
        getOrderDataListFailure(state, action) {
            state.loading = false;
            state.initialLoading = false;
            state.errorMessage = action.payload;
        },

        toggleOrderDataDetailsModal(state, action) {
            state.orderDetailsModal = !state.orderDetailsModal;
            state.selectedOrderData = action.payload;
            state.generateDocumentsErrorMessage = null;
            state.generateReversalDocumentErrorMessage = null;
            state.generateSingleDocumentLoading = {};
            state.generateSingleDocumentErrorMessage = null;
            state.regenerateDocumentLoading = {};
            state.regenerateDocumentErrorMessage = null;
            // Reset event log state when modal closes
            state.orderEvents = null;
            state.orderEventsLoading = false;
            state.orderEventsErrorMessage = null;
        },

        getOrderDataRequest(state) {
            state.orderDetailsLoading = true;
            state.orderDetailsErrorMessage = null;
        },
        getOrderDataSuccess(state, action) {
            state.selectedOrderData = action.payload;
            state.orderDetailsLoading = false;
        },
        getOrderDataFailure(state, action) {
            state.orderDetailsLoading = false;
            state.orderDetailsErrorMessage = action.payload;
        },

        generateDocumentsRequest(state) {
            state.generateDocumentsLoading = true;
            state.generateDocumentsErrorMessage = null;
        },
        generateDocumentsSuccess(state, action) {
            let orderData = action.payload;

            let dataPage = state.dataPage;
            if (dataPage && dataPage.content) {
                let index = dataPage.content.findIndex((item) => {
                    return item.externalUUID === orderData.externalUUID;
                });
                if (index >= 0) {
                    dataPage.content[index] = orderData;
                }
            }
            state.generateDocumentsLoading = false;
            state.dataPage = dataPage;
            state.selectedOrderData = state.selectedOrderData ? orderData : undefined;
        },
        generateDocumentsFailure(state, action) {
            state.generateDocumentsLoading = false;
            state.generateDocumentsErrorMessage = action.payload;
        },
        generateReversalDocumentRequest(state) {
            state.generateReversalDocumentLoading = true;
            state.generateReversalDocumentErrorMessage = null;
        },
        generateReversalDocumentSuccess(state, action) {
            let orderData = action.payload;

            let dataPage = state.dataPage;
            if (dataPage && dataPage.content) {
                let index = dataPage.content.findIndex((item) => {
                    return item.externalUUID === orderData.externalUUID;
                });
                if (index >= 0) {
                    dataPage.content[index] = orderData;
                }
            }
            state.generateReversalDocumentLoading = false;
            state.dataPage = dataPage;
            state.selectedOrderData = state.selectedOrderData ? orderData : undefined;
        },
        generateReversalDocumentFailure(state, action) {
            state.generateReversalDocumentLoading = false;
            state.generateReversalDocumentErrorMessage = action.payload;
        },

        generateSingleDocumentRequest(state, action) {
            state.generateSingleDocumentLoading = { ...state.generateSingleDocumentLoading, [action.payload]: true };
            state.generateSingleDocumentErrorMessage = null;
        },
        generateSingleDocumentSuccess(state, action) {
            let orderData = action.payload.orderData;
            let wrapperId = action.payload.wrapperId;
            state.generateSingleDocumentLoading = { ...state.generateSingleDocumentLoading, [wrapperId]: false };

            let dataPage = state.dataPage;
            if (dataPage && dataPage.content) {
                let index = dataPage.content.findIndex((item) => item.externalUUID === orderData.externalUUID);
                if (index >= 0) {
                    dataPage.content[index] = orderData;
                }
            }
            state.dataPage = dataPage;
            state.selectedOrderData = state.selectedOrderData ? orderData : undefined;
        },
        generateSingleDocumentFailure(state, action) {
            state.generateSingleDocumentLoading = { ...state.generateSingleDocumentLoading, [action.payload.wrapperId]: false };
            state.generateSingleDocumentErrorMessage = action.payload.error;
        },

        loadOrderEventsRequest(state) {
            state.orderEventsLoading = true;
            state.orderEventsErrorMessage = null;
            state.orderEvents = null;
        },
        loadOrderEventsSuccess(state, action) {
            state.orderEventsLoading = false;
            state.orderEvents = action.payload;
        },
        loadOrderEventsFailure(state, action) {
            state.orderEventsLoading = false;
            state.orderEventsErrorMessage = action.payload;
        },

        regenerateDocumentRequest(state, action) {
            state.regenerateDocumentLoading = { ...state.regenerateDocumentLoading, [action.payload]: true };
            state.regenerateDocumentErrorMessage = null;
        },
        regenerateDocumentSuccess(state, action) {
            let orderData = action.payload.orderData;
            let wrapperId = action.payload.wrapperId;
            state.regenerateDocumentLoading = { ...state.regenerateDocumentLoading, [wrapperId]: false };

            let dataPage = state.dataPage;
            if (dataPage && dataPage.content) {
                let index = dataPage.content.findIndex((item) => item.externalUUID === orderData.externalUUID);
                if (index >= 0) {
                    dataPage.content[index] = orderData;
                }
            }
            state.dataPage = dataPage;
            state.selectedOrderData = state.selectedOrderData ? orderData : undefined;
        },
        regenerateDocumentFailure(state, action) {
            state.regenerateDocumentLoading = { ...state.regenerateDocumentLoading, [action.payload.wrapperId]: false };
            state.regenerateDocumentErrorMessage = action.payload.error;
        },
    },
});

export default pathwayBillingDataSlice;
